export default {
  'payment': {
    'choosePlan': 'Choose\nThe Right Plan\nFor You',
    'monthly': '1 month',
    'yearly': '1 year',
    'discount': 'save {{ discount }}%',
    'register': 'Register',
    'registered': 'Registered',
    'plan': {
      'free': {
        'title': 'FREE',
        'description': 'Join the big community\n\nAccess to free tests to improve your knowledge'
      },
      'smart': {
        'title': 'Test Taker',
        'description': 'Suitable for students, working people, ...'
      },
      'talented': {
        'title': 'Test Creator',
        'description': 'Suitable for teachers, study groups, companies, ...'
      },
      'superb': {
        'title': 'Premium',
        'include': 'Includes all features SMART and TALENTED packages:',
        'description': 'Suitable for Test Taker and Test Creator'
      }
    }
  }
}
